import { Topology } from '../../../../../services/eventingApi';
import KpiTile from '../shared/KpiTile';
import { ageInSeconds, formatAge } from '../shared/format';
import { queueSubscriptions } from '../shared/subscriptions';

const SWEEPER_INTERVAL_MINUTES = 15;
const OUTBOX_WARN_SECONDS = 2 * SWEEPER_INTERVAL_MINUTES * 60;
const ATTEMPTS_ALERT = 3;

const OverviewKpis = ({ topology }: { topology: Topology }) => {
  const consumers = queueSubscriptions(topology.subscriptions);
  const pending = topology.outbox.reduce((sum, row) => sum + row.pending, 0);
  const oldest = Math.max(0, ...topology.outbox.map((row) => ageInSeconds(row.oldestOccurredAt)));
  const maxAttempts = Math.max(0, ...topology.outbox.map((row) => row.maxAttempts));
  const deadLetters = consumers.reduce((sum, row) => sum + (row.deadLetterMessages ?? 0), 0);

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      <KpiTile label="Outbox pendente" value={pending} hint={`${topology.outbox.length} serviço(s) com pendência`} tone={pending > 0 ? 'warn' : 'ok'} />
      <KpiTile label="Mais antiga no outbox" value={formatAge(oldest)} hint={`o varredor roda a cada ${SWEEPER_INTERVAL_MINUTES} min; alerta após 2 ciclos`} tone={oldest > OUTBOX_WARN_SECONDS ? 'alert' : 'ok'} />
      <KpiTile label="Tentativas (máx.)" value={maxAttempts} hint="falhas de publicação no SNS" tone={maxAttempts >= ATTEMPTS_ALERT ? 'alert' : 'ok'} />
      <KpiTile label="Mensagens em DLQ" value={deadLetters} hint={`${consumers.length} consumidor(es) com fila`} tone={deadLetters > 0 ? 'alert' : 'ok'} />
    </div>
  );
};

export default OverviewKpis;
